import {Field, Formik, FormikHelpers as FormikActions} from 'formik';
import React from 'react';
import {Button} from '~/components/Button';
import {EditorField, Form, FormColumn, FormControls, FormRow, FormTitle} from '~/components/Form';
import {IModalComponent, IModalComponentClose} from '~/components/Modal';
import {Intent} from '~/lib/intent';
import {prettyJSON} from '~/lib/json';
import {defaultGlobalConfig, GlobalConfig, GlobalConfigurationSchema} from '~/modules/Clients/models/GlobalConfig';

interface IGlobalAgencyConfigFormProps {
    configuration?: GlobalConfig;
    onSubmit?: (values: GlobalConfig, formikActions: FormikActions<GlobalConfig>, close: IModalComponentClose) => void;
}

export const GlobalAgencyConfigForm: IModalComponent<IGlobalAgencyConfigFormProps> = props => {
    const globalConfig = props.configuration || defaultGlobalConfig;
    const configString = typeof globalConfig.config === 'string'
        ? globalConfig.config
        : JSON.stringify(globalConfig.config || {});

    const initialConfig = configString === '{}' || !configString
        ? '{}'
        : prettyJSON(configString);

    return <Formik initialValues={{
            ...globalConfig,
            config: initialConfig
        }}
        validationSchema={GlobalConfigurationSchema}
        onSubmit={(values, actions) => props.onSubmit(values, actions, props.close)}
    >
        {({isSubmitting}) => <Form>
            <FormTitle>TagId config</FormTitle>
            <FormRow>
                <FormColumn>
                    <Field name='config'
                        options={{
                            mode: 'json',
                            disabled: isSubmitting,
                            canFullScreen: true
                        }}
                        component={EditorField}
                    />
                </FormColumn>
            </FormRow>
            <FormControls>
                <Button disabled={isSubmitting}
                    onClick={props.close}
                >Cancel</Button>
                <Button type='submit'
                    disabled={isSubmitting}
                    intent={Intent.PRIMARY}
                    rightIcon={isSubmitting && <i className='fa fa-spinner fa-spin'/>}
                >Save</Button>
            </FormControls>
        </Form>}
    </Formik>;
};
